import { render, staticRenderFns } from "./VesselMonitoringBayHold.vue?vue&type=template&id=771cfd73&scoped=true"
import script from "./VesselMonitoringBayHold.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringBayHold.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringBayHold.vue?vue&type=style&index=0&id=771cfd73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771cfd73",
  null
  
)

export default component.exports